<!--
数据块
-->
<template>
  <div class="container">
    <div class="contentBox">
        <div class="box" @click="pageTo('today')">
          <!--当日孕妇数量-->
          <a-statistic :value="form.dayNum" :value-style="{ color: '#fff' }" />
          <div class="title">{{ $t('home.today_num')}} </div>
        </div>
        <div class="border"></div>
        <div class="box" @click="pageTo('week')">
          <!--本周孕妇数量-->
          <a-statistic :value="form.weekNum" :value-style="{ color: '#fff' }" />
          <div class="title">{{ $t('home.week_num')}} </div>
        </div>
        <div class="border"></div>
        <div class="box" @click="pageTo('month')">
          <!--本月孕妇数量-->
          <a-statistic :value="form.monthNum" :value-style="{ color: '#fff' }" />
          <div class="title">{{ $t('home.month_num')}} </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Panel',
  components: {},
  props: {

  },
  data () {
    return {
      form: {}
    }
  },
  watch: {

  },
  mounted () {
    this.getChartData()
  },
  methods: {
    getChartData () {
      this.$get('web/chartData/getGravidaData').then((r) => {
        let data = r.data
        if (data.code === 200) {
          if (data.data) {
            this.form = data.data
          }
          this.$forceUpdate()
        } else {
          this.$message.error(data.message)
        }
      })
    },
    pageTo (e) {
      this.$router.push(`/manage/data?key=` + e)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 110px;
  background: #0897E3 url('../../../../../static/img/bg1.png') no-repeat center;
  background-size: 100%;
  border-radius: 8px;
  // padding: 20px;
//   background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contentBox {
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  padding: 20px 40px;
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .value {
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0em;
  }
  .title {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    margin-top: 10px;
    color: #F5F5F5;
  }
  }
  .border {
    width: 2px;
    height: 32px;
    background: #fff;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/manage/home/components/Panel.vue